export interface CreateSearchUrlParamProps {
  index: string;
  args: (string | number)[];
  value: string;
}

export function createSearchUrlParam(
  index: CreateSearchUrlParamProps['index'],
  args: CreateSearchUrlParamProps['args'],
  value: CreateSearchUrlParamProps['value'],
) {
  const formattedArgs = args.map((arg) => `[${arg}]`);
  return `${index}${encodeURIComponent(formattedArgs.join(''))}=${encodeURIComponent(value)}`;
}

export interface CreateSearchFacetUrlProps extends Pick<CreateSearchUrlParamProps, 'index' | 'value'> {
  pathname: string;
  facetType: string;
  attribute: string;
}

export function createSearchFacetUrl({
  pathname,
  index,
  facetType,
  attribute,
  value,
}: CreateSearchFacetUrlProps) {
  const param = createSearchUrlParam(index, [facetType, attribute, 0], value);
  return `${pathname}?${param}`;
}

export interface CreateSearchUrlProps extends Pick<CreateSearchUrlParamProps, 'index' | 'value'> {
  pathname: string;
}

export function createSearchUrl({ pathname, index, value }: CreateSearchUrlProps) {
  const param = createSearchUrlParam(index, ['query'], value);
  return `${pathname}?${param}`;
}
